import React from 'react'
import { Widget } from 'widgets-for-react'
import { any, async, fromJSX, Updater } from 'widgets-for-react'
import { subdepartmentBreadcrumbs } from '../../../../utils/breadcrumbs'
import { slugify } from '../../../../utils/utils'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, Page, SubdepartmentPage } from '../../cmsPageState'
import { SubdepartmentPageHeader } from './subdepartmentPageLayout'

export const subdepartmentPageWidget =
  (acceptVideoCookie: () => void) =>
  (page: SubdepartmentPage): Widget<Updater<Page>> =>
    any([
      async(page.hasWaitingTimesState).map(cmsPageStateUpdaters.hasWaitingTimesPageStateUpdater),
      fromJSX(() => { 
        const breadcrumbs = subdepartmentBreadcrumbs(page)
        return(
        <SubdepartmentPageHeader
          title={page.title}
          intro={page.intro}
          image={page.image}
          link={page.link}
          contactItems={page.subDepartment.contactItems}
          appointmentUrl={page.subDepartment?.appointmentUrl}
          waitingTimesUrl={
            page.subDepartment?.department &&
            page.hasWaitingTimesState.kind === 'loaded' &&
            page.hasWaitingTimesState.value
              ? `/wachttijden?department=${page.subDepartment.department.title}`
              : undefined
          }
          department={
            page.subDepartment
              ? {
                  title: page.subDepartment.department?.title,
                  url: breadcrumbs[breadcrumbs.length - 2].url,
                }
              : undefined
          }
          centrum={
            page.subDepartment?.department?.centrum
              ? {
                  title: page.subDepartment.department.centrum.title,
                  url: `/afdelingen-en-centra/${
                    page.subDepartment.department.centrum ? slugify(page.subDepartment.department.centrum.title) : ''
                  }`,
                }
              : page.subDepartment?.centrum
              ? {
                  title: page.subDepartment.centrum?.title,
                  url: `/afdelingen-en-centra/${
                    page.subDepartment.centrum.title ? slugify(page.subDepartment.centrum.title) : ''
                  }`,
                }
              : undefined
          }
          breadcrumbs={breadcrumbs}
        />
      )}),
      blocksWidget(acceptVideoCookie, {
        subdepartment: page.subDepartment ? { title: page.subDepartment.title, id: page.subDepartment.id } : undefined,
      })(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
    ])
